<!--
 * @Author: your name
 * @Date: 2020-10-16 11:36:31
 * @LastEditTime: 2020-10-29 17:59:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/workLocation/workDetail.vue
-->
<template>
  <div class="work-details-view">
    <div class="work-detail pageWidtn">
      <div
        v-if="pageLoading"
        class="loading"
        style="margin-top:200px;margin-bottom:200px"
      >
        <div class="align-center">
          <img style="width:100px;" src="@/assets/new-global.gif" alt="" />
        </div>
      </div>
      <Row :gutter="40" v-if="!pageLoading && detail">
        <Col span="17">
          <div class="left">
            <div
              class="banner"
              v-if="detail.projectFileList && detail.projectFileList.length > 0"
            >
              <Carousel
                :autoplay="detail.projectFileList.length > 1 ? true : false"
                arrow="always"
                :autoplay-speed="5000"
                v-model="swiperVal"
                :loop="detail.projectFileList.length > 1 ? true : false"
              >
                <CarouselItem
                  :key="index"
                  v-for="(item, index) in detail.projectFileList"
                >
                  <img class="swiperImg" :src="ossPrefix + item.key" alt="" />
                </CarouselItem>
              </Carousel>
            </div>

            <div class="top-title">
              <Row>
                <Col span="19">
                  <div class="name">{{ detail.name }}</div>
                </Col>
                <Col span="5">
                  <div class="price" style="text-align:right;">
                    {{ detail.salaryDisplay }}
                  </div>
                </Col>
              </Row>
              <div class="des">
                {{ detail.educationDisplay }}
                <span> / </span>
                {{ detail.experienceDisplay }}
              </div>
            </div>

            <div class="name-title">
              <span class="name-title-tag"></span>
              <span class="name-title-name">职位内容</span>
            </div>

            <div class="name-contont">
              <p>
                {{ detail.positionDescription }}
              </p>
            </div>

            <div class="name-title">
              <span class="name-title-tag"></span>
              <span class="name-title-name">任职要求</span>
            </div>

            <div class="name-contont">
              <p>
                {{ detail.requirements }}
              </p>
            </div>

            <div class="name-title">
              <span class="name-title-tag"></span>
              <span class="name-title-name">工作地址</span>
            </div>

            <div class="name-contont">
              <p>
                {{ detail.positionDetailAddress }}
              </p>
            </div>

            <div style="margin-bottom:55px">
              <Button
                class="red-btn"
                :loading="sendLoading"
                type="primary"
                style="width:150px"
                @click="sendHandle"
                >发送简历</Button
              >
            </div>
          </div>
        </Col>
        <Col span="7">
          <div class="right">
            <div class="bottom-name">
              <Row :gutter="20" type="flex" justify="center" align="middle">
                <Col span="5">
                  <img
                    v-if="!detail.avatarFile"
                    class="factory-img"
                    src="https://oss.zhulogic.com/planImage/fa/877_dir/5WKBaPrpdAWtkHiEjjS4HjyGrKzdXPfh75.png"
                    alt=""
                  />
                  <img
                    v-else
                    class="factory-img"
                    :src="ossPrefix + detail.avatarFile.key"
                    alt=""
                  />
                </Col>
                <Col span="19">
                  <div class="fatory">{{ detail.company }}</div>
                </Col>
              </Row>
            </div>
            <div style="margin-top:20px">
              <p
                style="margin-top:10px;font-size: 14px;font-weight: 500;color: #5B6066;"
              >
                手机号：{{ detail.phone }}
              </p>
              <p
                style="margin-top:10px;font-size: 14px;font-weight: 500;color: #5B6066;"
              >
                邮箱：{{ detail.email }}
              </p>
              <p
                style="margin-top:10px;font-size: 14px;font-weight: 500;color: #5B6066;"
              >
                官网：<a target="_blank" :href="detail.website">{{
                  detail.website
                }}</a>
              </p>
              <p
                style="margin-top:10px;font-size: 14px;font-weight: 500;color: #5B6066;"
              >
                地址：{{ detail.companyDetailAddress }}
              </p>
            </div>
            <div style="margin-top:60px">
              <p style=";font-size: 14px;font-weight: 500;color: #83888E;">
                公司介绍：
              </p>
              <p style="font-size: 14px;font-weight: 500;color: #83888E;">
                {{ detail.companyDescription }}
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      swiperVal: 0,
      pageLoading: false,
      detail: null,
      sendLoading: false,
    }
  },
  methods: {
    getDetail() {
      this.pageLoading = true
      axios
        .get(`/designer_api/job_position/${this.$route.query.id}`)
        .then((res) => {
          this.detail = res
          this.pageLoading = false
        })
        .then((res) => {
          this.pageLoading = false
        })
    },
    // 判断自己是否已经创建简历
    isJobResume() {
      return new Promise((resovle, reject) => {
        axios
          .get(`/designer_api/job/resume`)
          .then((res) => {
            if (!res) {
              this.$Modal.confirm({
                title: '提示',
                content: '<p>还没有创建简历，是否去创建自己的简历？</p>',
                onOk: () => {
                  // 跳转到简历创建页面
                  this.$router.push({ path: '/my-work?index=2' })
                },
                onCancel: () => {
                  this.sendLoading = false
                },
              })
              reject(false)
            } else {
              resovle(true)
            }
          })
          .catch((err) => {
            reject(false)
          })
      })

      return false
    },
    // 发送简历
    sendHandle() {
      // 判断是否登录
      this.isJobResume().then((bl) => {
        if (bl) {
          this.sendLoading = true
          // 提示
          this.$Modal.confirm({
            title: '发送提示',
            content: '<p>您的信息以及附件文件将发送至该企业</p>',
            onOk: () => {
              this.sendLoading = true
              axios
                .post(`/designer_api/job_position/${this.$route.query.id}`)
                .then((res) => {
                  this.$Message.success('发送成功')
                  this.sendLoading = false
                })
                .catch((err) => {
                  this.sendLoading = false
                })
            },
            onCancel: () => {
              this.sendLoading = false
            },
          })
        }
      })
    },
  },
  created() {
    this.getDetail()
  },
}
</script>

<style lang="scss" scoped>
.work-details-view {
  background: #f3f5f9;
  padding-top: 30px;
}
.work-detail {
  min-height: 600px;
  .left {
    width: 100%;
  }
  .banner {
    height: 280px;
    overflow: hidden;
    .swiperImg {
      width: 100%;
      height: 280px;
      object-fit: cover;
    }
    /deep/ .ivu-carousel-arrow {
      i {
        font-size: 30px;
        color: #fff;
      }
    }
    /deep/ .ivu-carousel-dots li button {
      background: #fff !important;
    }
  }

  .top-title {
    padding: 20px;
    background: #fff;
    margin-top: 20px;
    .name {
      font-size: 16px;
      font-weight: 500;
      color: #373737;

      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .price {
      font-size: 16px;
      font-weight: 500;
      color: #e56a69;

      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .des {
      font-size: 14px;
      font-weight: 500;
      color: #999999;
      margin-top: 5px;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
  }

  .name-title {
    margin-top: 50px;
    margin-bottom: 30px;
    .name-title-tag {
      display: inline-block;
      width: 3px;
      background: #e56a69;
      margin-right: 8px;
      vertical-align: middle;
      height: 14px;
      margin-top: -5px;
    }
    .name-title-name {
      font-size: 16px;
      font-weight: bold;
      color: #373737;
    }
  }
  .name-contont {
    margin-bottom: 50px;
    > p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-top: 5px;
    }
  }

  .bottom-name {
    .factory-img {
      display: inline-block;
      width: 60px;
      height: 60px;
      object-fit: cover;
    }
    .fatory {
      font-size: 16px;
      font-weight: bold;
      color: #373737;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
  }
}
</style>
